// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import $http  from './lib/network.js'
import Util from './lib/utils.js'
import $toast from './lib/toast.js'

// import layer from 'vue-layer'
// import 'vue-layer/lib/vue-layer.css';

Vue.prototype.$layer = { 
  msg(text){
    $toast.toast({ txt: text })
  }
};

// import layer from 'vue-layer'

// import VConsole from 'vconsole'

// new VConsole()

Vue.config.productionTip = false

router.beforeEach((to, from,next) => {
  //微信config域名导致签名失败----解决方案一
  // try {
  //   // wx.hideAllNonBaseMenuItem();
  // } catch (error) {
    
  // }
  if (to.meta&&to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
//微信config域名导致签名失败----解决方案二
// router.afterEach((to,from)=>{
  // url中携带？forcesessionid=xxx时，使用该sessionid，不去重新登录（PDF生成页面，直接服务器调用页面来生成PDF）
  // let forcesessionid = Util.getUrlQuery('forcesessionid');


  // if(!Util.isIos()){ //安卓重新注册wxsdk
  //   Util.useJsdK();
  // }
  // else{
  //   let _location = window.location;
  //   let path = _location.protocol + '//' +_location.host+'/xbsh5'+to.fullPath;
  //   store.dispatch('setCurrentUrl',path)
  // }
// })

// if(window.location){
//   Object.defineProperty(window.location,'_href',{
//     get(){
//       return Util.getCurrentUrl();
//     },
//   })
// }

/* eslint-disable no-new */
Vue.prototype.$http = $http;
Vue.prototype.$util = Util;
Vue.prototype.$toast = $toast.toast;
Vue.prototype.$loading = $toast.loading;
Vue.prototype.$toasterr = $toast.toasterr;
Vue.prototype.$alert = $toast.alert;
// Vue.prototype.$layer = layer(Vue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})


// WEBPACK FOOTER //
// ./src/main.js